import ObjCommon from './ObjCommon';

class User extends ObjCommon {
  un = '';
  pw = '';
  email = '';
  firstName = '';
  lastName = '';
  uType = '';

  constructor(id) {
    super(id);
  } 

}

export default User;
